import { CAREER_PROBLEMS_DIFFICULTIES } from '../../../../constants'

export const CARREER_PROBLEMS_DIFFICULTIES_COLORS = {
  [CAREER_PROBLEMS_DIFFICULTIES.hard]: 'bg-red-400 border-red-400',
  [CAREER_PROBLEMS_DIFFICULTIES.medium]: 'bg-amber-300 border-amber-300',
  [CAREER_PROBLEMS_DIFFICULTIES.easy]: 'bg-green-400 border-green-400',
}
